import { useQuery, gql, useLazyQuery } from '@apollo/client';
import { TiposUsuarioQuery, TiposUsuarioQueryVariables } from './__generated__/TiposUsuarioQuery';

const TIPOS_USUARIO_QUERY = gql`
  query TiposUsuarioQuery($descricao: String, $pagina: Int, $itens_por_pagina: Int) {
    tiposUsuario(
      filter: { descricao: $descricao, pagina: $pagina, itens_por_pagina: $itens_por_pagina }
    ) {
      id_tipo_usuario
      dsc_tipo_usuario
    }
  }
`;

const useTiposUsuarioQuery = (variables?: TiposUsuarioQueryVariables) => {
  return useQuery<TiposUsuarioQuery, TiposUsuarioQueryVariables>(TIPOS_USUARIO_QUERY, {
    variables,
  });
};

const useTiposUsuarioLazyQuery = () => {
  return useLazyQuery<TiposUsuarioQuery, TiposUsuarioQueryVariables>(TIPOS_USUARIO_QUERY);
};

export { useTiposUsuarioQuery, useTiposUsuarioLazyQuery };
